<template>
  <div>
    <div class="box-top">
      <div class="box-top-l">
        <div class="title">进度预览<div class="off">
          <span style="font-size:16px">已完成</span>
          <el-switch
            v-model="flag"
            active-color="#4D6EBB"
            inactive-color="#13ce66"
            @change="offNo"
            >
          </el-switch>
          <span style="font-size:16px">未完成</span>
        </div></div>
        <div v-if="showS" class="cont-ec" id="cont-ec"></div>
      </div>
      <div class="box-top-m">
        <div class="title">总进度</div>
        <el-progress style="margin-top:25%" :width="200" :stroke-width="30" type="circle" :percentage="num"></el-progress>
      </div>
      <div class="box-top-r">
        <div class="title">年度数据统计</div>
        <div class="cont-ec1" id="cont-ec1"></div>
      </div>
    </div>
    <div class="table">
      <div class="table-title">
        <span class="button" @click="addNode">新增计划</span>
      </div>
      <el-table :data="listData">
        <el-table-column label="序号">
          <template slot-scope="scope">
            <span>{{scope.row.index}}</span>
          </template>
        </el-table-column>
        <el-table-column label="发起角色">
          <template slot-scope="scope">
            <span>{{scope.row.userName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="关键节点">
          <template slot-scope="scope">
            <span>{{scope.row.nodeName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="计划开始时间">
          <template slot-scope="scope">
            <span>{{scope.row.startTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="计划结束时间">
          <template slot-scope="scope">
            <span>{{scope.row.completeTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
             <span class="table-button" style="color: #8EA3CE;margin-right: 5px;" @click="modNode(scope.row)">编辑</span>
             <span class="table-button button-red" style="border: 1px solid rgba(236, 15, 15, 0.8);color: #EC0F0F;" @click="delNode(scope.row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新增窗口 -->
    <el-dialog
        :title="dialogTitle"
        :visible.sync="addFormVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        class="add-form"
        width="500px"
    >
        <el-form
        :model="addForm"
        ref="addForm"
        label-width="150px"
        :label-position="labelPosition"
        >
          <el-form-item label="选择节点：">
            <el-cascader
              v-model="nodeVal"
              :options="nodeOpts"
              :props="props"
              collapse-tags
              clearable>
            </el-cascader>
          </el-form-item>
          <el-form-item label="计划开始日期：">
            <el-date-picker
              v-model="addForm.startTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="计划完成日期：">
            <el-date-picker
              v-model="addForm.completeTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="sumbitAddRow()" style="background-color: #4D6EB1;">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
  import util from '../../../../untils/util'
  import myHttp from '../../../../untils/port'
  import base from '../../../../untils/base'
  import { number } from 'echarts'
  export default {
    data() {
      return {
        listData: [],
        groupId: '',
        nodeOpts:[],//级联列表
        props: { value: 'id',label:'nodeTypeName',children:'childList' },//级联
        dataText: '数据加载中...',
        nodeVal:[], //选中节点列表
        //弹出框
        dialogTitle:'',
        addFormVisible:false,
        addForm:{
          projectNodeId:'',//id
          projectId:'',
          sysNodeId:'',
          parentNodeId:'',
          completeTime:'',
          startTime:''
        },
        labelPosition:'right',
        info:{allDay:'0',progress:0,setmentProgress:0},
        flag:false,
        showS:true,
        num:0
        }
        
    },
    created() {
      this.groupId = this.$store.state.groupId
      if ('' == this.groupId) {
        this.$store.commit('setGroupId')
        this.groupId = this.$store.state.groupId
      }
      this.getInfoByProId()
      // this.getNodeType()
      this.getProgress()
      this.getData()
      this.getNodePlanProgress()
      this.getYearStatis()
    },
    methods: {
      offNo(){
        let that = this
        myHttp.getNodePlanProgress({
          projectId:util.session.get('groupId'),
          flag:this.flag==false?'1':'0'
        }).then(res=>{
          console.log(res)
          let listName=[]
          let listS = []
          let data = res.data
          for(let key in data){
            if(data[key].length!=0){
              listName.push(key)
            }
          }
          listName.forEach((item,index)=>{
            data[item].forEach((item1,index1)=>{
              item1.writeTime = item1.writeTime.split('-')[1]
              if(item1.writeTime.indexOf('0')==0){
                item1.writeTime = Number(item1.writeTime.split('')[1])
              }else{
                item1.writeTime = Number(item1.writeTime)
              }
            })
            let a = {
              name: item,
              type: 'line',
              stack: 'Total',
              data: [],
              itemStyle: {
                      normal: {
                        areaStyle: {
                          type: "default",
                          opacity: 0.2
                        },
                      },
                    },
            }
            data[item][0].writeTime
            for(let i=1;i<data[item][0].writeTime;i++){
              let c = 0
              a.data.push(c)
            }
            for(let i=0;i<data[item].length;i++){
              a.data.push(data[item][i].completeRate)
            }
            listS.push(a)
          })
          console.log(listS,'test')
          if(this.flag){
            that.echarts1(listS,listName,1)
          }else{
            that.echarts1(listS,listName,2)
          }
        })
      },
      // 年度进度预览
      getYearStatis(){
        let that = this
        myHttp.getYearStatis({
          projectId:util.session.get('groupId'),
        }).then(res=>{
          console.log(res)
          let list = []
          for(let key in res.data){
            let a = {value:res.data[key],name:key}
            list.push(a)
          }
          
          this.echarts2(list)
        })
      },
      //年统计图
        echarts2(itemSt){
            let chartDom1 = document.getElementById('cont-ec1');
            let myChart1 = this.$echarts.init(chartDom1);
            myChart1.setOption({
                color:['#0d3a95','#4d7bd8','#8394b5','#34579d'],
                series: [
                    {
                      label: {
                show: true,
                position: "inner",
                formatter: "{b}{c}%",
              },
                    name: 'Nightingale Chart',
                    type: 'pie',
                    radius: [0, '80%'],
                    center: ['50%', '50%'],
                    roseType: 'radius',
                    itemStyle: {
                        borderRadius: 0
                    },
                    data: itemSt
                    }
                ]
            });
        },
      //进度预览
      getNodePlanProgress(){
        let that = this
        myHttp.getNodePlanProgress({
          projectId:util.session.get('groupId'),
          flag:this.flag==true?'0':'1'
        }).then(res=>{
          console.log(res)
          let listName=[]
          let listS = []
          let data = res.data
          for(let key in data){
            if(data[key].length!=0){
              listName.push(key)
            }
          }
          listName.forEach((item,index)=>{
            data[item].forEach((item1,index1)=>{
              item1.writeTime = item1.writeTime.split('-')[1]
              if(item1.writeTime.indexOf('0')==0){
                item1.writeTime = Number(item1.writeTime.split('')[1])
              }else{
                item1.writeTime = Number(item1.writeTime)
              }
            })
            let a = {
              name: item,
              type: 'line',
              stack: 'Total',
              data: [],
              itemStyle: {
                      normal: {
                        areaStyle: {
                          type: "default",
                          opacity: 0.2
                        },
                      },
                    },
            }
            data[item][0].writeTime
            for(let i=1;i<data[item][0].writeTime;i++){
              let c = 0
              a.data.push(c)
            }
            for(let i=0;i<data[item].length;i++){
              a.data.push(data[item][i].completeRate)
            }
            listS.push(a)
          })
          console.log(listS,'test')
          that.echarts1(listS,listName,0)
        })
      },
      echarts1(listS,nameData,type){
        let chartDom = document.getElementById('cont-ec');
        let myChart = this.$echarts.init(chartDom);
        this.showS = false
        let num = 0
        console.log(listS,nameData,type)
        listS.forEach((item,index)=>{
         num+= item.data[item.data.length-1]
        })
        console.log(listS.length)
        this.num = (num/(listS.length*100))*100
        console.log(this.num)
        if(type==1){
          this.showS = true
          let chartDom = document.getElementById('cont-ec');
        let myChart = this.$echarts.init(chartDom);
          myChart.setOption({
          tooltip: {
            trigger: 'axis',
            formatter: function(params){
              if(params.length>0){
                let result = params[0].name + "<br>";
                params.forEach(function (item){
                  //item.value
                  if (true) {
                    result +=
                      item.marker +
                      " " +
                      item.seriesName +
                      " : " +
                      item.value +'%'+
                      "</br>";
                  } else if (item.seriesName == "完成进度") {
                    result +=
                      item.marker +
                      " " +
                      item.seriesName +
                      " : " +
                      item.value +
                      "%</br>";
                  }
                })
                    return result;
              }
            }
          },
          width:'83%',
          legend: {
            orient: 'vertical' ,
            data: nameData,
            right:'0',
            top:'10%'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          
          color:['#0D3A95','#2C60C8','#95B3F0','#7385A8','#6272D8','#27437C','#698FDB','#01739F','#278E9F'],
          xAxis: {
            axisLine: {
                    lineStyle: {
                      type: 'solid',
                      color: '',
                      width: '1'
                    }
                  },
            type: 'category',
        splitLine:{
                    show: true, //让网格显示
                    lineStyle: {//网格样式
                      color:['#07DBFF'], //网格的颜色
                      width:1, //网格的宽度
                      type:'dashed' //网格是实实线，可以修改成虚线以及其他的类型
                    }
                  },
            boundaryGap: false,
            data: ['1月份', '2月份', '3月份', '4月份', '5月份', '6月份', '7月份','8月份', '9月份', '10月份', '11月份','12月份']
          },
          yAxis: {
            axisLabel:{
              show:true,
              interval:'auto',
              formatter:'{value}%'
            },
            min:0,
            max:100,
           
			scale : true,
            splitNumber : 5,
            type: 'value',
            splitLine:{
              show: true,
              lineStyle: {
                color:['#07DBFF'],
                width:1,
                type:'dashed'
              }
            },
          },
          series: listS
        })
        }else if(type==2){
          this.showS = true
          this.$echarts.init(document.getElementById('cont-ec')).dispose();
          let chartDom = document.getElementById('cont-ec');
        let myChart = this.$echarts.init(chartDom);
          console.log('触发了2')
          myChart.setOption({
          tooltip: {
            trigger: 'axis',
            formatter: function(params){
              if(params.length>0){
                let result = params[0].name + "<br>";
                params.forEach(function (item){
                  //item.value
                  if (true) {
                    result +=
                      item.marker +
                      " " +
                      item.seriesName +
                      " : " +
                      item.value +'%'+
                      "</br>";
                  } else if (item.seriesName == "完成进度") {
                    result +=
                      item.marker +
                      " " +
                      item.seriesName +
                      " : " +
                      item.value +
                      "%</br>";
                  }
                })
                    return result;
              }
            }
          },
          width:'83%',
          legend: {
            orient: 'vertical' ,
            data: nameData,
            right:'0',
            top:'10%'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          
          color:['#0D3A95','#2C60C8','#95B3F0','#7385A8','#6272D8','#27437C','#698FDB','#01739F','#278E9F'],
          xAxis: {
            axisLine: {
                    lineStyle: {
                      type: 'solid',
                      color: '',
                      width: '1'
                    }
                  },
            type: 'category',
        splitLine:{
                    show: true, //让网格显示
                    lineStyle: {//网格样式
                      color:['#07DBFF'], //网格的颜色
                      width:1, //网格的宽度
                      type:'dashed' //网格是实实线，可以修改成虚线以及其他的类型
                    }
                  },
            boundaryGap: false,
            data: ['1月份', '2月份', '3月份', '4月份', '5月份', '6月份', '7月份','8月份', '9月份', '10月份', '11月份','12月份']
          },
          yAxis: {
            axisLabel:{
              show:true,
              interval:'auto',
              formatter:'{value}%'
            },
            min:0,
            max:100,
           
			scale : true,
            splitNumber : 5,
            type: 'value',
            splitLine:{
              show: true,
              lineStyle: {
                color:['#07DBFF'],
                width:1,
                type:'dashed'
              }
            },
          },
          series: listS
        })
        }else{
          this.showS = true
          console.log('触发了')
          myChart.setOption({
          tooltip: {
            trigger: 'axis',
            formatter: function(params){
              if(params.length>0){
                let result = params[0].name + "<br>";
                params.forEach(function (item){
                  if (item.value) {
                    result +=
                      item.marker +
                      " " +
                      item.seriesName +
                      " : " +
                      item.value +'%'+
                      "</br>";
                  } else if (item.seriesName == "完成进度") {
                    result +=
                      item.marker +
                      " " +
                      item.seriesName +
                      " : " +
                      item.value +
                      "%</br>";
                  }
                })
                    return result;
              }
            }
          },
          width:'83%',
          legend: {
            orient: 'vertical' ,
            data: nameData,
            right:'0',
            top:'10%'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          
          color:['#0D3A95','#2C60C8','#95B3F0','#7385A8','#6272D8','#27437C','#698FDB','#01739F','#278E9F'],
          xAxis: {
            axisLine: {
                    lineStyle: {
                      type: 'solid',
                      color: '',
                      width: '1'
                    }
                  },
            type: 'category',
        splitLine:{
                    show: true, //让网格显示
                    lineStyle: {//网格样式
                      color:['#07DBFF'], //网格的颜色
                      width:1, //网格的宽度
                      type:'dashed' //网格是实实线，可以修改成虚线以及其他的类型
                    }
                  },
            boundaryGap: false,
            data: ['1月份', '2月份', '3月份', '4月份', '5月份', '6月份', '7月份','8月份', '9月份', '10月份', '11月份','12月份']
          },
          yAxis: {
            axisLabel:{
              show:true,
              interval:'auto',
              formatter:'{value}%'
            },
            min:0,
            max:100,
           
			scale : true,
            splitNumber : 5,
            type: 'value',
            splitLine:{
              show: true,
              lineStyle: {
                color:['#07DBFF'],
                width:1,
                type:'dashed'
              }
            },
          },
          series: listS
        })
        }
      },
      //获取数据
    getData() {
      var that = this
      myHttp.findPlanProjectNode({
        projectId:this.groupId,
      }).then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data || []
            for (var i = 0; i < list.length; i++) {
               list[i].index = (i + 1) //(that.currentPage - 1) * that.pageSize + 
               list[i].isSet = false
               list[i].minPer = i==(list.length-1)?0:parseFloat(list[i+1].completePercentage)
               if(that.minPer < parseFloat(list[i].completePercentage)){
                 that.minPer = parseFloat(list[i].completePercentage)
               }
            }
            that.listData = list
            console.log(that.listData)
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.dataText = '暂无数据'
          }
      })
    },

    
    // 施工进度
    getProgress(){
      var that =this
      myHttp.projectContractDuration({
        projectId: this.groupId,
      }).then(function (resp) {
        if (resp.data.code == '200') {
           console.log(resp.data.data)
          var  info = resp.data.data
          // 施工进度
          var now = util.myTime.getCurTime()
          info.restDay = util.myTime.getdayByDate(info.startDate,now)
          if (info.allDay == 0) {
              info.progress = 0
            }else {
              var progress = ((parseInt(info.restDay) /parseInt(info.allDay)) * 100 ).toFixed(2)
              info.progress =progress>100?100:progress
            }
             that.info =info
        }
      
      })
    },

    //获取数据
    getInfoByProId(){
      var that = this
      myHttp.getProjectById({
        id:util.session.get('groupId')
      }).then(function(resp){
        if (resp.data.code == '200') {
          var data = resp.data.data.project
          that.getNodeType(data.projectType)
        }
      })
    },
    /**
    * 节点列表
    */
    getNodeType(type){
      var that = this
      myHttp.proNodeList({
        nodeType:type,
        linkId:this.groupId
      }).then(function(resp){
        console.log(resp);
        if (resp.data.code == '200') {
          var list = resp.data.data.list || []
          for(var i=0;i<list.length;i++){
            if(list[i].childList && list[i].childList.length==0){
              delete list[i].childList
            }
          }
          that.nodeOpts =list
        }
      })
    },
     /**
      * 添加节点弹出框
      */
     addNode(row){
       this.dialogTitle = '新增计划'
       this.addFormVisible = true

       this.addForm.projectNodeId = ''
       this.addForm.projectId = this.groupId
       this.addForm.sysNodeId = ''
       this.addForm.parentNodeId = ''
       this.addForm.completeTime = ''
       this.addForm.startTime = ''
       this.addForm.createBy = util.session.get('user').id
       this.nodeVal = []
     },
     //提交节点
     sumbitAddRow(){
        if(this.nodeVal.length==0){
         this.$message.error('请选择关键节点')
         return
        }
        if(this.addForm.completeTime==''||this.addForm.startTime==''){
         this.$message.error('请选择开始/完成时间')
         return
        }
        var that = this
        if(this.nodeVal.length==1){
          this.addForm.parentNodeId = '0'
          this.addForm.sysNodeId = this.nodeVal[0]
        }else if(this.nodeVal.length==2){
          this.addForm.parentNodeId = this.nodeVal[0]
          this.addForm.sysNodeId = this.nodeVal[1]
        }
        if(!this.addForm.projectNodeId || this.addForm.projectNodeId==''){
          myHttp.addPlanProjectNode(this.addForm).then(function(resp){
            if(resp.data.code=='200'){
              that.addFormVisible = false
              that.$message.success('添加成功')
              that.getData()
            }else{
              that.$message.error(resp.data.msg)
            }
          })
        }else{
          myHttp.editPlanProjectNode(this.addForm).then(function(resp){
            if(resp.data.code=='200'){
              that.addFormVisible = false
              that.$message.success('编辑成功')
              that.getData()
            }else{
              that.$message.error(resp.data.msg)
            }
          })
        }
     },
     /** 
      * 修改节点进度
     */
    modNode(item){
       this.dialogTitle = '修改计划'
       this.addFormVisible = true
       this.addForm.projectNodeId = item.projectNodeId
       this.addForm.projectId = this.groupId
       this.addForm.parentNodeId = ''
       this.addForm.sysNodeId = ''
       this.addForm.startTime = item.startTime
       this.addForm.completeTime = item.completeTime
       delete this.addForm.createBy
       if(item.parentNodeId=='0'||item.parentNodeId==''||!item.parentNodeId){
         this.nodeVal = [item.sysNodeId]
       }else{
          this.nodeVal = [item.parentNodeId,item.sysNodeId]
       }
    },
    /**
     * 删除
     */
    delNode(row){
      var that = this;
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.deletePlanProjectNode({
          projectNodeId : row.projectNodeId 
        }).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
            that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        },function() {})
      }).catch(err => {
      })
    },
    },
  }
</script>

<style scoped>
.box-top{
  height: 450px;
  margin-bottom: 8px;
  display: flex;
}
.box-top-l{
  height: 48vh;
    width: 46.7vw;
  border-radius: 6px;
background: #FFFFFF;
box-shadow: 0px 0px 10px 0px rgba(77, 110, 177, 0.3);
}
.box-top-m{
  height: 48vh;
    width: 19vw;
  border-radius: 6px;
background: #fff;
box-shadow: 0px 0px 10px 0px rgba(77, 110, 177, 0.3);
  margin-left: 8px;
}
.box-top-r{
  height: 48vh;
    width: 21vw;
  border-radius: 6px;
background: #FFFFFF;
box-shadow: 0px 0px 10px 0px rgba(77, 110, 177, 0.3);
  margin-left: 8px;
}
.title{
  height: 6vh;
  padding-left: 0.9vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #E7E7E7;
}
.button{
  display: inline-block;
  width: 80px;
  height: 32px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
}
.button:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.table{
  min-height: 80vh;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.table-title{
  text-align: right;
  padding: 12px 16px;
  border-bottom: 2px solid #E7E7E7;
}
.table-button{
  display: inline-block;
  width: 50px;
  height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-family: 'SourceHanSansCN-Regular';
  font-size: 14px;
  cursor: pointer;
}
.button-red:hover{
  background-color: #F56C6C;
  color: #fff!important;
}
.cont-ec{
  width: 46.7w;
    height: 41.7vh;
}
.cont-ec1{
  width: 21vw;
    height: 41.7vh;

}
.off{
  width: 8vw;
  margin-right: 6%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>